var map = {
	"./client-01.png": 3666,
	"./client-02.png": 3706,
	"./client-03.png": 5358,
	"./client-04.png": 8397,
	"./client-05.png": 6530,
	"./client-06.png": 6592,
	"./client-07.png": 449,
	"./client-08.png": 3758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6413;